import Marquee from "react-fast-marquee";
import { COMPLIMENTARY } from "@/lib/brand";
import { Sparkles } from "lucide-react";

export default function ComplimentaryMarquee() {
  return (
    <section
      data-testid="complimentary-section"
      className="relative bg-[#0B1B3D] text-white py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 mb-10">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles className="w-4 h-4 text-[#10B981]" />
          <span className="text-sm font-medium text-[#10B981]">On the house</span>
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.04] max-w-3xl">
          Complimentary services to{" "}
          <span className="italic font-light text-[#10B981]">experience</span> us.
        </h2>
        <p className="mt-5 text-white/70 max-w-xl">
          Pick any one — no commitment, no obligation. Just clarity on where you stand today.
        </p>
      </div>

      <Marquee speed={48} gradient gradientColor="#0B1B3D" gradientWidth={120} className="py-6">
        {COMPLIMENTARY.concat(COMPLIMENTARY).map((item, i) => (
          <div
            key={`${item}-${i}`}
            className="mx-8 flex items-center gap-6"
            data-testid={`comp-item-${i}`}
          >
            <span
              className="font-display text-5xl md:text-7xl lg:text-8xl font-light text-transparent"
              style={{ WebkitTextStroke: "1px rgba(255,255,255,0.55)" }}
            >
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#10B981]" />
          </div>
        ))}
      </Marquee>

      <Marquee speed={36} direction="right" gradient gradientColor="#0B1B3D" gradientWidth={120} className="py-2 mt-2">
        {COMPLIMENTARY.slice().reverse().concat(COMPLIMENTARY).map((item, i) => (
          <div key={`r-${item}-${i}`} className="mx-6 flex items-center gap-4">
            <span className="font-body text-sm md:text-base uppercase tracking-[0.25em] text-white/55">
              {item}
            </span>
            <span className="text-[#D4AF37]">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
